// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__gnh5j"};